import { render, staticRenderFns } from "./promo.vue?vue&type=template&id=baa4d476&scoped=true&"
import script from "./promo.vue?vue&type=script&lang=js&"
export * from "./promo.vue?vue&type=script&lang=js&"
import style0 from "./promo.vue?vue&type=style&index=0&id=baa4d476&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa4d476",
  null
  
)

export default component.exports